import { css } from 'emotion'

export const CloneIconStyles = css``
